import { Clear } from "@mui/icons-material";
import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputLabel,
  OutlinedInput,
  Typography,
} from "@mui/material";
import { useCallback, useContext, useState } from "react";
import { HttpClientContext, X_REQUEST_ID } from "../../app/client";
import { AxiosError } from "axios";
import Loading from "../common/Loading";
import Error from "../common/Error";

export default function Data() {
  const [cmd, setCmd] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>(undefined);
  const [output, setOutput] = useState<string | null>(null);

  const client = useContext(HttpClientContext);

  const runCmd = useCallback(() => {
    if (cmd.length === 0) return;

    setLoading(true);
    setError(undefined);

    client
      ?.post<object>("/api/data", { cmd })
      .then((res) => setOutput(JSON.stringify(res.data, null, 4)))
      .catch((e: AxiosError) => setError(e.response?.headers[X_REQUEST_ID]))
      .finally(() => setLoading(false));
  }, [client, cmd]);

  let comp = <></>;
  if (loading) comp = <Loading />;
  else if (error) comp = <Error error={error} />;
  else if (output === null) comp = <Typography>No output</Typography>;
  else comp = <OutputView output={output} />;

  return (
    <>
      <Box sx={{ display: "flex", gap: 2, width: "100%" }}>
        <FormControl size="small" fullWidth>
          <InputLabel>Command</InputLabel>
          <OutlinedInput
            label="Command"
            value={cmd}
            onChange={(e) => setCmd(e.target.value)}
            endAdornment={
              <IconButton
                onClick={() => setCmd("")}
                sx={{
                  visibility: cmd.length > 0 ? "visible" : "hidden",
                }}
              >
                <Clear />
              </IconButton>
            }
          />
        </FormControl>
        <Button variant="outlined" onClick={() => runCmd()}>
          Run
        </Button>
      </Box>

      {comp}
    </>
  );
}

function OutputView(props: { output: string }) {
  const { output } = props;

  return (
    <Typography
      variant="caption"
      width="100%"
      sx={{
        whiteSpace: "pre",
      }}
    >
      {output}
    </Typography>
  );
}
